import type { DemoSourceSummary, DemoToneAnalysisFormValues } from '../models/demoToneAnalysis'
import type { ToneAnalysisRequest } from '../models/toneAnalysis'

export function buildToneAnalysisRequest(values: DemoToneAnalysisFormValues): ToneAnalysisRequest {
  const source = {
    sourceType: 'RemoteUrl' as const,
    location: values.sourceMode === 'youtube'
      ? values.youtubeUrl.trim()
      : `tone-library:${values.artist.trim()}-${values.songTitle.trim()}`,
    originalFileName: undefined,
    contentType: undefined,
  }

  return {
    songTitle: values.songTitle.trim(),
    artist: values.artist.trim() || undefined,
    presetBaseName: values.presetBaseName.trim(),
    audioSource: source,
    analysisOptions: {
      detectMultipleGuitarLayers: values.maximumGuitarLayers === 2,
      detectToneChanges: true,
      maximumGuitarLayers: values.maximumGuitarLayers,
      reuseSimilarScenes: true,
      sceneSimilarityThreshold: 0.85,
    },
  }
}

export function getDemoSourceSummary(values: DemoToneAnalysisFormValues): DemoSourceSummary {
  if (values.sourceMode === 'youtube') {
    return {
      type: 'YouTube link',
      name: values.youtubeUrl.trim(),
    }
  }

  return {
    type: 'Tone Library',
    name: [values.artist.trim(), values.songTitle.trim()].filter(Boolean).join(' - '),
  }
}
